import RepositoryService from 'src/services/repository'

const resource = 'rejectionCause'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  restore: idList => RepositoryService.crud.post(`${resource}/restore`, { idList }),
  getRejectionListForOperation: params => RepositoryService.crud.getList(`${resource}/available`, params),
}
